module.exports = __webpack_public_path__ + "static/media/nanda.79e28160.jpg";